module.exports = __webpack_public_path__ + "img/circle-outline.3885ebdc.svg";